import { createAction, createSlice } from '@reduxjs/toolkit'
import castArray from 'lodash/castArray'
import { LoginResult } from '@lk/api'

interface StoreOTPAttributes {
  username: string
  hash: string
  expire: any
}

export const storeOTP = createAction<StoreOTPAttributes>('[PERSIST] STORE_OTP')

export const forgetOTP = createAction('[PERSIST] FORGET_OTP', (username: string | string[]) => ({
  payload: castArray(username),
}))

interface PrepareStoreAuthAction {
  username: string
  expire: number
  loginResult: LoginResult
}

export const storeAuth = createAction(
  '[PERSIST] STORE_AUTH',
  ({ username, expire, loginResult }: PrepareStoreAuthAction) => ({
    payload: {
      username: username.toLowerCase(),
      STK: loginResult.STK,
      ServerName: loginResult.ServerName,
      DisplayToken: loginResult.DisplayToken,
      Database: loginResult.Database,
      STKExpire: expire,
    },
  }),
)

export const forgetAuth = createAction('[PERSIST] FORGET_AUTH')

export const neededBuildUpdateSlice = createSlice({
  name: 'neededBuildUpdateSlice',
  initialState: false,
  reducers: {
    storeBuildNeededUpdate: () => true,
    forgetAboutBuildUpdate: () => false,
  },
})

export const { storeBuildNeededUpdate, forgetAboutBuildUpdate } = neededBuildUpdateSlice.actions
